var _style, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWelcomeFigure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 372.6",
    style: {
      enableBackground: "new 0 0 500 372.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#EBEBEB;}\r\n\t.st1{display:none;fill:#EBEBEB;}\r\n\t.st2{fill:#F5F5F5;}\r\n\t.st3{fill:#E0E0E0;}\r\n\t.st4{fill:#FAFAFA;}\r\n\t.st5{fill:#E6E6E6;}\r\n\t.st6{fill:#F0F0F0;}\r\n\t.st7{fill:#FFFFFF;}\r\n\t.st8{fill:#407BFF;}\r\n\t.st9{fill:#263238;}\r\n\t.st10{opacity:0.3;fill:#FFFFFF;enable-background:new    ;}\r\n\t.st11{fill:#FFC3BD;}\r\n\t.st12{opacity:0.2;enable-background:new    ;}\r\n\t.st13{opacity:0.2;}\r\n\t.st14{fill:#ED847E;}\r\n\t.st15{opacity:0.7;fill:#FFFFFF;enable-background:new    ;}\r\n\t.st16{opacity:0.2;fill:#FFFFFF;enable-background:new    ;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_2_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Background_Complete_1_"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 327.6,
    className: "st0",
    width: 500,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50.1,
    y: 343.7,
    className: "st0",
    width: 33.1,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168.8,
    y: 346.4,
    className: "st0",
    width: 8.7,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84.2,
    y: 334.4,
    className: "st0",
    width: 19.2,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 404.4,
    y: 336.1,
    className: "st0",
    width: 43.2,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 389.1,
    y: 336.1,
    className: "st0",
    width: 6.3,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 274.9,
    y: 340.3,
    className: "st0",
    width: 93.7,
    height: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M263,283h193.1c3.1,0,5.7-2.6,5.7-5.7V5.9c0-3.2-2.6-5.7-5.7-5.7c0,0,0,0,0,0H263c-3.2,0-5.7,2.6-5.7,5.7 v271.4C257.3,280.4,259.8,283,263,283z M456.1,0.4c3,0,5.5,2.4,5.5,5.5v271.4c0,3-2.4,5.5-5.5,5.5H263c-3,0-5.5-2.4-5.5-5.5V5.9 c0-3,2.4-5.5,5.5-5.5H456.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M46.7,283h193.1c3.2,0,5.7-2.6,5.7-5.7V5.9c0-3.2-2.6-5.7-5.7-5.7H46.7c-3.1,0-5.7,2.6-5.7,5.7v271.4 C41,280.4,43.5,283,46.7,283z M239.8,0.4c3,0,5.5,2.4,5.5,5.5v271.4c0,3-2.4,5.5-5.5,5.5H46.7c-3,0-5.5-2.4-5.5-5.5V5.9 c0-3,2.4-5.5,5.5-5.5H239.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 365.8,
    y: 20.8,
    className: "st2",
    width: 73.3,
    height: 121.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 439.1,
    y: 20.8,
    className: "st3",
    width: 1.5,
    height: 121.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 373.3,
    y: 26.2,
    className: "st4",
    width: 58.5,
    height: 110.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 275.2,
    y: 63.4,
    className: "st2",
    width: 73.3,
    height: 121.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 348.5,
    y: 63.4,
    className: "st3",
    width: 1.5,
    height: 121.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 282.6,
    y: 68.7,
    className: "st4",
    width: 58.5,
    height: 110.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M395.8,296.3c-1.8-33,3-86,8.2-104.4c0.7-2.4,1.5-5.2,2.7-5.6l0,0c3.4-1.1,4.9,4.3,4.5,6.1 c-2,8.9-3.9,30.9-5.7,69.1c-0.9,19,0,32.1-2.4,34.8L395.8,296.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M401.2,222.7c-4.8-15.4-66-31.3-48.4-14.7c4.4,4.1,24.8,15,33.2,26.5c6.5,8.9,13.1,23.9,14.9,32.2 C401.7,249.3,404.4,233,401.2,222.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M394.2,242.3c-10.7-23.5-44.8-27.7-35.6-15.3c3.6,4.9,16.8,10.4,25.2,21.9c6.5,8.9,13.1,23.9,14.8,32.2 C399.5,263.6,398.7,252.1,394.2,242.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M407.6,240.3c12.6-30.2,58.2-32.6,46.1-18.6c-4.6,5.3-20.7,15.1-32.9,27.8c-9.5,9.8-20.1,26-23.8,34.9 C399.4,265.9,402.6,252.5,407.6,240.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M402.4,206.5c-11.3-20.7-45.5-22.9-35.7-11.6c3.8,4.4,16.3,10.1,24.4,21.2c6.3,8.6,13.9,19.9,15.6,28 C407.4,227.1,407.4,215.6,402.4,206.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M412.2,206.9c8.9-12.9,48.9-27,38.5-15.4c-10.9,12.2-18.7,10.1-29,20.8c-8,8.3-17,22.1-20.1,29.6 C403.5,226.2,405.8,216.1,412.2,206.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M401.6,192c-5.7-10.2-29-17.7-22.9-9.9c4.2,5.4,9.4,9.1,14.8,16.5c4.2,5.7,9.9,12.9,11,18.3 C405,205.7,405,198.1,401.6,192z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M410.8,195.1c5.7-6.3,36.2-21.3,29.2-11.7c-2.7,3.8-14.4,13-22.2,21.1c-6.1,6.3-12.8,11.4-15.1,17.2 C404.2,209.8,405.1,201.4,410.8,195.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M403,217.3c8.3-9.2,69.1-21.1,53.5-10.9c-5.3,3.5-28.8,9.5-40.3,21.3c-8.9,9.2-12.1,24.5-15.5,32.9 C391.7,245.9,394.7,226.5,403,217.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M413.4,294.9l-0.8,27.6c-0.1,5.2-1.3,5.1-2.8,5.1h-19.6c-1.5,0-2.7,0.1-2.8-5.1l-0.8-27.6 c-0.1-5.7,1.2-10.5,2.8-10.5h21.2C412.2,284.5,413.5,289.2,413.4,294.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M414.6,289.5h-29.1c-0.4,0-0.7-0.2-0.8-0.6l-0.7-5.3c0-0.4,0.3-0.8,0.7-0.8c0,0,0.1,0,0.1,0h30.5 c0.4,0,0.8,0.3,0.8,0.7c0,0,0,0.1,0,0.1l-0.7,5.3C415.3,289.2,415,289.5,414.6,289.5z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 209.1,
    y: 172.8,
    className: "st6",
    width: 22,
    height: 148.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 320.9,
    className: "st6",
    width: 166.9,
    height: 6.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55.8,
    y: 172.7,
    className: "st2",
    width: 153.4,
    height: 148.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 211.4,
    y: 166.9,
    className: "st6",
    width: 22.5,
    height: 5.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 166.9,
    className: "st4",
    width: 158.4,
    height: 5.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M63.8,242.7h137.3v-57.6H63.8V242.7z M199.8,241.4H65.1v-55.1h134.8L199.8,241.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M63.8,308.6h137.3v-56.8H63.8V308.6z M199.8,307.3H65.1V253h134.8L199.8,307.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M105.7,196.4h53.5c1.3,0,2.4-1.1,2.4-2.4l0,0c0-1.3-1.1-2.4-2.4-2.4h-53.5c-1.3,0-2.4,1.1-2.4,2.4l0,0 C103.4,195.4,104.4,196.4,105.7,196.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M159.2,263.1h-53.5c-1.3,0-2.4-1.1-2.4-2.4l0,0c0-1.3,1.1-2.4,2.4-2.4h53.5c1.3,0,2.4,1.1,2.4,2.4l0,0 C161.5,262,160.5,263.1,159.2,263.1z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "139.6,166.9 76,166.9 70.8,110.2 134.4,110.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "141.8,166.9 78.2,166.9 73,110.2 136.6,110.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "83.9,160.6 79.8,116.4 130.9,116.4 134.9,160.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "154.3,125.5 158.1,166.9 127.6,166.9 123.8,125.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "155.9,125.5 159.7,166.9 129.2,166.9 125.4,125.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "151.7,130 154.7,162.3 133.4,162.3 130.4,130  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "Shadow_1_"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "_Path__1_",
    className: "st2",
    cx: 250,
    cy: 351.7,
    rx: 193.9,
    ry: 12.6
  })), /*#__PURE__*/React.createElement("g", {
    id: "Bubble_1_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M203.7,52.9c3.8-9.5,14.5-14.2,24.1-10.5c0.2,0.1,0.5,0.2,0.7,0.3c8.5,3.8,13.1,14.7,9.9,23.4 c-1.6,4.4-4.8,8-9,10.2c-1.7,0.8-3.2,2.1-4.3,3.8l-2.6,4.2c-1.8,2.9-5.4,4.1-8.5,2.9l-6.7-2.6c-3.1-1.2-4.9-4.5-4.3-7.8l1-5.1 c0.3-1.8,0.1-3.6-0.5-5.3C201.9,62,202,57.2,203.7,52.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M213.2,95.5c0.4,0,0.8-0.1,1.2-0.3c1.6-0.7,2.3-2.5,1.6-4.1c-0.3-0.8-0.9-1.4-1.7-1.7l-8.8-3.5 c-1.6-0.7-3.4,0-4.1,1.6s0,3.4,1.6,4.1c0.1,0,0.2,0.1,0.3,0.1l8.8,3.5C212.4,95.4,212.8,95.5,213.2,95.5z M204.4,86.8 c0.3,0,0.5,0,0.8,0.2l8.9,3.5c1.1,0.4,1.6,1.6,1.2,2.7c-0.2,0.5-0.6,0.9-1.1,1.2c-0.5,0.2-1.1,0.2-1.6,0l-8.8-3.5 c-1.1-0.4-1.6-1.7-1.2-2.7c0.2-0.5,0.6-0.9,1.1-1.1C203.8,86.9,204.1,86.8,204.4,86.8L204.4,86.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M208.7,100.9c0.8,0,1.5-0.5,1.8-1.2l0.1-0.4c0.4-1-0.1-2.1-1.1-2.5c0,0,0,0,0,0l-5.5-2.2 c-1-0.4-2.1,0.1-2.5,1.1c0,0,0,0,0,0l-0.1,0.4c-0.4,1,0.1,2.1,1.1,2.5l5.5,2.2C208.2,100.9,208.4,100.9,208.7,100.9z M203.3,95.4 c0.1,0,0.2,0,0.3,0.1l5.5,2.2c0.5,0.2,0.7,0.7,0.5,1.2c0,0,0,0,0,0l-0.1,0.4c-0.1,0.2-0.3,0.4-0.5,0.5c-0.2,0.1-0.5,0.1-0.7,0 l-5.5-2.2c-0.5-0.2-0.7-0.7-0.5-1.2c0,0,0,0,0,0l0.1-0.4C202.6,95.7,203,95.5,203.3,95.4L203.3,95.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M225.1,70.6c2.1,0,3.8-1.7,3.8-3.7c0-2.1-1.7-3.8-3.7-3.8c-1.5,0-2.9,0.9-3.5,2.4l-1.4,3.5l3.5,1.4 C224.2,70.6,224.6,70.7,225.1,70.6z M225.1,64.1c0.3,0,0.7,0.1,1,0.2c1.4,0.5,2.2,2.1,1.7,3.5c-0.5,1.4-2.1,2.2-3.5,1.7 c-0.1,0-0.1,0-0.2-0.1l-2.6-1l1-2.6C222.9,64.8,224,64.1,225.1,64.1L225.1,64.1z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "214,87.4 221.5,68.4 214.6,65.7 207.1,84.7 208.1,85.1 215.2,67 220.2,69 213.1,87.1  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M215.2,67l1.4-3.5c0.8-1.9-0.2-4.1-2.1-4.9c-1.9-0.8-4.1,0.2-4.9,2.1c-0.8,1.9,0.2,4.1,2.1,4.9c0,0,0,0,0,0 L215.2,67z M213.1,59.4c0.3,0,0.7,0.1,1,0.2c1.4,0.6,2.1,2.1,1.6,3.6l-1,2.6l-2.6-1c-1.4-0.6-2.1-2.2-1.6-3.6 C210.9,60.1,212,59.4,213.1,59.4L213.1,59.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M199.7,114.7c3.8,0,7.5-0.3,11.2-0.9l-0.2-1c-3.6,0.6-7.3,0.9-11,0.9L199.7,114.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M179,125l-0.5-1.1c-1.8-4.1-2.2-8.7-1-13.1c3.9,1.4,7.9,2.4,12,3l0.1-1c-4.2-0.6-8.3-1.7-12.3-3.2l-0.5-0.2 l-0.1,0.5c-1.3,4.3-1.1,9,0.5,13.2C164.9,118.4,152,101,152,80.3C152,62,173.5,47,199.8,47s47.7,15,47.7,33.3 c0,13.3-11.4,25.4-29,30.6l0.3,1c18-5.4,29.7-17.8,29.7-31.6c0-18.9-21.9-34.3-48.7-34.3S151,61.5,151,80.4 c0,21.7,14,39.9,26.9,44.3L179,125z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M179.5,89l-33.3-6c-2.4-0.4-4-2.7-3.6-5.1l3.5-19.8c0.4-2.4,2.7-4,5.1-3.6l33.3,6c2.4,0.4,4,2.7,3.6,5.1 l-3.5,19.8C184.1,87.8,181.9,89.4,179.5,89z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "159.2,70.7 171,66.4 168.8,78.8  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "Character_1_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M369.7,246.8h-85c-1.8,0-3.2-1.4-3.2-3.2v-4.5c0-1.8,1.4-3.2,3.2-3.2h85c1.8,0,3.2,1.4,3.2,3.2v4.5 C372.9,245.4,371.5,246.8,369.7,246.8z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "285.7,349.4 283.2,349.4 286.1,246.8 289.6,246.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "285.7,349.4 283.2,349.4 286.1,246.8 289.6,246.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "309,349.4 311.6,349.4 308.6,246.8 305.1,246.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "309,349.4 311.6,349.4 308.6,246.8 305.1,246.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "345.4,349.4 342.9,349.4 345.8,246.8 349.3,246.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "345.4,349.4 342.9,349.4 345.8,246.8 349.3,246.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "368.7,349.4 371.3,349.4 368.4,246.8 364.9,246.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "368.7,349.4 371.3,349.4 368.4,246.8 364.9,246.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "258.7,323.3 249.7,320.3 257.1,299.2 266.1,302.3  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M250.3,316.8l9.9,4.3c0.3,0.1,0.5,0.5,0.4,0.8c0,0,0,0.1,0,0.1l-3.8,7.6c-0.5,0.8-1.5,1.2-2.4,0.8 c-3.4-1.6-4.9-2.5-9.3-4.4c-2.7-1.2-8.1-3.3-11.4-5.4s-0.7-5.3,0.9-4.6c3.9,1.5,10.4,1.4,13.9,0.6 C249.1,316.5,249.8,316.6,250.3,316.8z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "266.1,302.3 257.1,299.2 252.9,311.3 262,313.9  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M322.6,207.4c0,0-45,8.1-48.6,22.9c-7.1,29.2-23.2,74.9-23.2,74.9l17.1,4.9c0,0,24.5-52.4,27.6-70 c25.2,0,56,2,60-8.7c3.5-9.5,2.3-24,2.3-24L322.6,207.4z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "268.8,313.2 248.8,306.6 250.5,297.6 272.3,305.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "297.9,326.5 287.9,327.3 293.8,302.7 303.1,304.8  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M288.2,324.9l10.7-1.2c0.3-0.1,0.6,0.2,0.7,0.5c0,0,0,0.1,0,0.1l0.6,8.5c0,0.9-0.7,1.7-1.7,1.9 c-3.7,0.3-5.5,0.3-10.2,0.8c-2.9,0.3-8.6,1.2-12.6,1s-3.2-4.2-1.5-4.5c4.1-0.7,9.7-4,12.4-6.4C287,325.3,287.6,325,288.2,324.9z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "303.1,304.8 293.8,302.7 290.8,315.2 300.2,316.8  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M346,207.4c0,0-54.7,8.2-52.2,28.9c3.6,29.9-5.7,73-5.7,73l17.5,3.1c0,0,12.9-53.7,13-71.6 c17.8,0,48.9,1.3,52.9-9.5c3.5-9.5,2.3-24,2.3-24H346z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "306.9,315.4 286.3,310.9 287.1,301.8 309.6,307.1  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M317.1,149.8c-1.5,5.7-2.9,11.5-4.3,17.2s-2.8,11.5-4.2,17.2l-1.1,4.2l-0.6,2.1l-0.3,1v0.1v0.1 c0,0,0-0.1,0-0.1c0.1-0.2,0.2-0.4,0.3-0.6c0-0.1,0.1-0.2,0.1-0.2l0.1-0.1l0.2-0.2c0.2-0.2,0.2-0.2,0.2-0.1 c-0.1,0.1-0.2,0.2-0.4,0.3c-0.4,0.3-0.9,0.6-1.4,0.8c-1.1,0.5-2.3,1-3.6,1.5c-5.2,1.9-10.9,3.6-16.5,5.4l0.9,6.4 c3.1,0,6.1-0.1,9.2-0.4c3.1-0.3,6.2-0.7,9.3-1.3c1.6-0.3,3.3-0.7,4.9-1.3c0.9-0.3,1.8-0.6,2.7-1.1c0.5-0.2,1.1-0.5,1.5-0.9 c0.7-0.4,1.3-1,1.9-1.6c0.2-0.2,0.4-0.4,0.5-0.6l0.3-0.4c0.1-0.1,0.2-0.3,0.3-0.5c0.2-0.4,0.4-0.7,0.5-1.1l0.2-0.5l0.4-1.1 l0.8-2.2c0.5-1.4,1-2.9,1.4-4.3c1.8-5.8,3.5-11.5,5-17.3s3-11.6,4.3-17.4L317.1,149.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M331.2,142.9c-5.5-6.1-14.2-1.8-17.9,11.9c-1.8,6.7-1.2,10.1-1.2,10.1l18.9,5.8 C335.1,161.8,338.7,151.2,331.2,142.9z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M331.2,142.9c-5.5-6.1-14.2-1.8-17.9,11.9c-1.8,6.7-1.2,10.1-1.2,10.1l18.9,5.8C335.1,161.8,338.7,151.2,331.2,142.9z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M275.9,195.7l1.7-0.5c1-0.3,2.1-0.4,3.2-0.3l3.6,0.4c2.4,0.6,4.4,2.1,5.6,4.3l1.2,2.4c-0.6,4.5-9.7,3-9.7,3 H273l0.3-6C273.3,197.5,274.4,196.1,275.9,195.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M270,185.9c0.3,1.6,1,3.2,2.1,4.4c0.9,1.3,1.9,2.6,2.8,4c1.9,2.6,3.9,5.2,6,7.6c0.2,0.2,0.6,0.3,0.8,0.1 c0.2-0.2,0.3-0.5,0.1-0.7c-1.5-2.9-3.1-5.7-4.9-8.4c-0.9-1.4-1.7-2.7-2.6-4.1c-0.8-1.5-1.9-2.7-3.4-3.6c-0.3-0.2-0.7,0-0.9,0.3 C270,185.7,270,185.8,270,185.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M329.9,137l10.7-3.1l13.7-0.6c4.3-0.2,8.2,2.5,9.5,6.6c2.6,8,5,19.5,6.8,29.5c2.1,12.6,3.2,25.3,3.2,38 h-51.2c-1-28.5-4.4-42.4-6.4-52.4c-1.2-6.1,1.9-12.3,7.5-15L329.9,137z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M344.2,139c-1.3,3.3-6.3,10.5-12.2,13.3c-3.2-2.3-4-7.5-4.4-9.9L344.2,139z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M327.6,142.4c-0.4-1.3-0.2-2.7,0.4-3.9c0.8-1.3,0.6-2.8-0.2-4.3c-0.7-1.2-1.5-2.3-2.5-3.3l6.7-7.9l5.5-6.3 c0.5,5.9,0.9,13.3,5.6,17.9c1.6,1.6,2,2.1,1,4.5c-1.3,3.3-6,8-11.8,10.8C329.9,148.1,328.2,145.4,327.6,142.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M327.5,129.4l3.8-6.1c0.1,0.2,0.2,0.3,0.2,0.5c0.3,0.8,0.6,1.5,0.8,2.4c0.7,2.7-1.6,6.6-4.2,8.5 c-0.1-0.2-0.2-0.4-0.3-0.5c-0.6-1.2-1.4-2.2-2.3-3.2c0,0-0.1-0.1-0.2-0.1L327.5,129.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M314.2,114.7c-0.9,5.7-9-8.9-4.5-12.1C315.3,98.7,315.9,103.9,314.2,114.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M337.3,107.3c0.5,9.2,1.3,14.6-2.9,19.9c-6.4,8-18.6,5.4-21.9-3.5c-3-7.9-3.4-21.7,5.5-26.5 S336.8,98.1,337.3,107.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M319.2,101.8c0,0-5.9,5.8-10.1,3.4s-5-8.6,0-14c2.4-2.6,6.1-5.2,13.3-5c-0.6,0.6-1.3,1-2,1.2 c0,0,9.2-1.5,15.5,1.1c-0.5,0.8-1.2,1.4-2,1.9c6.2-0.5,12.2,2,8,7.8c5.6,0.5,6.9,7.8,3.9,12.5s-3.5,8.3-7.5,10.5 c0-6.5-1.5-8-1.5-8c-2.9-1.2-6.2-7.4-5.5-10.5C325.1,105.2,318.5,106,319.2,101.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M340.5,98c2-1.4,3.5-3.3,4.4-5.6c0.7,3.2-2.6,6.9-2.6,6.9L340.5,98z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M341.9,112.4c-0.1,2.1-0.9,4.1-2.3,5.7c-1.9,2-4.5,0.3-5-2.3c-0.4-2.3,0.6-5.8,3-6.9S342,109.8,341.9,112.4 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M322.2,112.1c0.1,0.8-0.1,1.5-0.6,1.6s-1-0.4-1.2-1.2s0.1-1.5,0.6-1.6S322.1,111.3,322.2,112.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M313.8,114.1c0.2,0.8-0.1,1.5-0.6,1.6s-1-0.4-1.2-1.2s0.1-1.5,0.6-1.6S313.6,113.4,313.8,114.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M316.6,114.1c-0.2,2.2-0.7,4.3-1.5,6.4c1.4,0.7,3.2-0.4,3.2-0.4L316.6,114.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M319.8,124.3c1.8-0.4,3.3-1.5,4.3-3c0-0.1,0-0.3-0.1-0.3c-0.1,0-0.2,0-0.3,0.1c-1.1,1.7-2.9,2.7-4.8,2.9 c-0.1,0-0.2,0.1-0.2,0.2c0,0,0,0,0,0c0,0.1,0.1,0.2,0.2,0.2c0,0,0,0,0,0C319.2,124.4,319.5,124.4,319.8,124.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M323.4,109c0.1,0,0.1-0.1,0.2-0.1c0.2-0.2,0.1-0.5-0.1-0.6c-1.1-0.9-2.6-1.3-4-0.9c-0.2,0.1-0.4,0.3-0.3,0.6 c0,0,0,0,0,0c0.1,0.2,0.3,0.4,0.6,0.3c1.1-0.3,2.3,0,3.1,0.7C323,109.1,323.2,109.1,323.4,109z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M312.7,109.2c0-0.1,0-0.2,0-0.2c-0.1-0.2-0.3-0.4-0.6-0.3c0,0,0,0,0,0c-1.4,0.4-2.5,1.4-3,2.8 c-0.1,0.2,0.1,0.5,0.3,0.6c0,0,0,0,0,0c0.2,0.1,0.5-0.1,0.6-0.3c0,0,0,0,0,0c0.4-1.1,1.3-1.9,2.4-2.2 C312.6,109.5,312.7,109.4,312.7,109.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M352.2,147.1c1.9,5.5,3.8,11.2,5.5,16.8c0.9,2.8,1.7,5.6,2.4,8.4c0.7,2.7,1.2,5.4,1.6,8.1 c0,0.3,0.1,0.6,0.1,0.9v0.4c0,0.1,0,0.4,0,0.3s0.1,0.1,0,0.3c-0.3,0.8-0.7,1.5-1.2,2.1c-1.7,1.9-3.7,3.6-5.8,5 c-4.8,3.2-9.8,6.2-15,8.7l2.1,6.1c3.1-0.7,6.2-1.5,9.1-2.6c3.1-1,6-2.3,8.9-3.7c3.2-1.5,6.1-3.5,8.7-5.9c1.7-1.5,3-3.4,3.9-5.4 c0.6-1.3,0.9-2.7,1-4.2c0-0.4,0-0.6,0-0.9v-0.7c0-0.5,0-0.9,0-1.4c-0.2-3.3-0.6-6.6-1.2-9.9c-0.6-3.2-1.4-6.2-2.2-9.3 c-1.6-6-3.6-12-5.8-17.8L352.2,147.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M355,133.3c-9.8-0.1-11.6,7.5-6.3,19.6c2,4.4,4.5,8.5,7.4,12.3l16.2-8.6C370.1,147,366.2,133.4,355,133.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M328,197.1l3.6-2c0.6-0.3,1.3-0.4,1.9-0.4l4.3,0.6c2.9,0.3,5,2.5,6.6,4.4l1.8,2.2 c0.1,4.5-11.3,3.4-11.3,3.4l-10-0.1l0.3-3.9C325.3,199.6,326.4,197.9,328,197.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Desk_1_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 114.7,
    y: 203.1,
    className: "st8",
    width: 270.7,
    height: 12.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 297.5,
    y: 203.1,
    className: "st10",
    width: 87.8,
    height: 12.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 378.1,
    y: 215.8,
    className: "st8",
    width: 4.1,
    height: 139.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 378.1,
    y: 215.8,
    className: "st15",
    width: 4.1,
    height: 139.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 300.7,
    y: 215.8,
    className: "st8",
    width: 4.1,
    height: 139.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 300.7,
    y: 215.8,
    className: "st15",
    width: 4.1,
    height: 139.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195.2,
    y: 215.8,
    className: "st8",
    width: 4.1,
    height: 139.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195.2,
    y: 215.8,
    className: "st15",
    width: 4.1,
    height: 139.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.8,
    y: 215.8,
    className: "st8",
    width: 4.1,
    height: 139.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.8,
    y: 215.8,
    className: "st15",
    width: 4.1,
    height: 139.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M144.1,147.1h74c2.6,0.1,4.8,2,5.3,4.6l7.7,46.9c0.4,2-0.9,4-2.9,4.5c-0.3,0.1-0.6,0.1-0.9,0.1h-74 c-2.6-0.1-4.8-2-5.3-4.6l-7.7-46.9c-0.4-2,0.9-4,2.9-4.5C143.4,147.1,143.7,147.1,144.1,147.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M260.7,203.1H191c-0.5,0-0.8-0.4-0.8-0.8v-1.4c0-0.5,0.4-0.8,0.8-0.8h69.7c0.5,0,0.8,0.4,0.8,0.8v1.4 C261.5,202.7,261.1,203.1,260.7,203.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M144.1,147.1h72.3c2.6,0.1,4.8,2,5.3,4.6l7.7,46.9c0.4,2-0.9,4-2.9,4.5c-0.3,0.1-0.6,0.1-0.9,0.1h-72.3 c-2.6-0.1-4.8-2-5.3-4.6l-7.7-46.9c-0.4-2,0.9-4,2.9-4.5C143.4,147.1,143.7,147.1,144.1,147.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M335.5,200c0,0-23.8,3.6-35.3-1.1c-5.4,2.6-24.5,3.9-31.2,1.1c2.1,2.4,6.9,3.1,6.9,3.1h50.3 C331,203.1,334.7,201,335.5,200z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M335.5,200c0,0-23.8,3.6-35.3-1.1c-5.4,2.6-24.5,3.9-31.2,1.1c2.1,2.4,6.9,3.1,6.9,3.1h50.3 C331,203.1,334.7,201,335.5,200z"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Background_Complete"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 31.6,
    y: 713.6,
    className: "st0",
    width: 500,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81.7,
    y: 729.7,
    className: "st0",
    width: 33.1,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200.3,
    y: 732.4,
    className: "st0",
    width: 8.7,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.8,
    y: 720.4,
    className: "st0",
    width: 19.2,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 435.9,
    y: 722.1,
    className: "st0",
    width: 43.2,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 420.7,
    y: 722.1,
    className: "st0",
    width: 6.3,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306.4,
    y: 726.3,
    className: "st0",
    width: 93.7,
    height: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M294.6,669h193.1c3.1,0,5.7-2.6,5.7-5.7V391.9c0-3.2-2.6-5.7-5.7-5.7c0,0,0,0,0,0H294.6 c-3.2,0-5.7,2.6-5.7,5.7v271.4C288.8,666.5,291.4,669,294.6,669z M487.6,386.4c3,0,5.5,2.4,5.5,5.5v271.4c0,3-2.4,5.5-5.5,5.5 H294.6c-3,0-5.5-2.4-5.5-5.5V391.9c0-3,2.4-5.5,5.5-5.5H487.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M78.2,669h193.1c3.2,0,5.7-2.6,5.7-5.7V391.9c0-3.2-2.6-5.7-5.7-5.7H78.2c-3.1,0-5.7,2.6-5.7,5.7v271.4 C72.6,666.5,75.1,669,78.2,669z M271.3,386.4c3,0,5.5,2.4,5.5,5.5v271.4c0,3-2.4,5.5-5.5,5.5H78.2c-3,0-5.5-2.4-5.5-5.5V391.9 c0-3,2.4-5.5,5.5-5.5H271.3z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 397.4,
    y: 406.9,
    className: "st2",
    width: 73.3,
    height: 121.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 470.7,
    y: 406.9,
    className: "st3",
    width: 1.5,
    height: 121.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 404.8,
    y: 412.2,
    className: "st4",
    width: 58.5,
    height: 110.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306.8,
    y: 449.4,
    className: "st2",
    width: 73.3,
    height: 121.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 380.1,
    y: 449.5,
    className: "st3",
    width: 1.5,
    height: 121.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 314.2,
    y: 454.8,
    className: "st4",
    width: 58.5,
    height: 110.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M427.4,682.3c-1.8-33,3-86,8.2-104.4c0.7-2.4,1.5-5.2,2.7-5.6l0,0c3.4-1.1,4.9,4.3,4.5,6.1 c-2,8.9-3.9,30.9-5.7,69.1c-0.9,19,0,32.1-2.4,34.8L427.4,682.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M432.8,608.8c-4.8-15.4-66-31.3-48.4-14.7c4.4,4.1,24.8,15,33.2,26.5c6.5,8.9,13.1,23.9,14.9,32.2 C433.3,635.3,436,619,432.8,608.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M425.8,628.3c-10.7-23.5-44.8-27.7-35.6-15.3c3.6,4.9,16.8,10.4,25.2,21.9c6.5,8.9,13.1,23.9,14.8,32.2 C431,649.6,430.3,638.2,425.8,628.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M439.2,626.3c12.6-30.2,58.2-32.7,46.1-18.6c-4.6,5.3-20.7,15.1-32.9,27.8c-9.5,9.8-20.1,26-23.8,35 C431,652,434.1,638.5,439.2,626.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M433.9,592.5c-11.3-20.7-45.5-22.9-35.7-11.6c3.8,4.5,16.3,10.1,24.4,21.2c6.3,8.6,13.9,19.9,15.6,28 C439,613.2,438.9,601.7,433.9,592.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M443.7,592.9c8.9-12.9,48.9-27,38.5-15.4c-10.9,12.2-18.7,10.1-29,20.8c-8,8.3-17,22-20.1,29.6 C435.1,612.3,437.4,602.1,443.7,592.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M433.2,578.1c-5.7-10.2-29-17.7-22.9-9.9c4.2,5.4,9.4,9.1,14.8,16.5c4.2,5.7,9.9,13,11,18.3 C436.6,591.8,436.6,584.2,433.2,578.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M442.4,581.2c5.7-6.3,36.2-21.3,29.2-11.7c-2.7,3.8-14.4,13-22.2,21.1c-6.1,6.3-12.8,11.4-15.1,17.2 C435.8,595.9,436.7,587.5,442.4,581.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M434.6,603.3c8.3-9.2,69.1-21.1,53.5-10.9c-5.3,3.5-28.8,9.5-40.3,21.3c-8.9,9.2-12.1,24.5-15.5,32.9 C423.3,631.9,426.2,612.6,434.6,603.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M445,681l-0.8,27.6c-0.1,5.2-1.3,5.1-2.8,5.1h-19.6c-1.5,0-2.7,0.1-2.8-5.1l-0.8-27.6 c-0.1-5.7,1.2-10.5,2.8-10.5h21.2C443.8,670.5,445,675.3,445,681z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M446.1,675.5H417c-0.4,0-0.7-0.2-0.8-0.6l-0.7-5.3c0-0.4,0.3-0.8,0.7-0.8c0,0,0.1,0,0.1,0h30.5 c0.4,0,0.8,0.3,0.8,0.7c0,0,0,0.1,0,0.1l-0.7,5.3C446.9,675.3,446.5,675.5,446.1,675.5z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240.7,
    y: 558.8,
    className: "st6",
    width: 22,
    height: 148.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91.6,
    y: 706.9,
    className: "st6",
    width: 166.9,
    height: 6.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 87.3,
    y: 558.8,
    className: "st2",
    width: 153.4,
    height: 148.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 243,
    y: 553,
    className: "st6",
    width: 22.5,
    height: 5.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84.6,
    y: 553,
    className: "st4",
    width: 158.4,
    height: 5.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M95.4,628.7h137.3v-57.6H95.4V628.7z M231.4,627.5H96.6v-55.1h134.8L231.4,627.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M95.4,694.6h137.3v-56.8H95.4V694.6z M231.4,693.3H96.6v-54.3h134.8L231.4,693.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M137.3,582.5h53.5c1.3,0,2.4-1.1,2.4-2.4l0,0c0-1.3-1.1-2.4-2.4-2.4h-53.5c-1.3,0-2.4,1.1-2.4,2.4l0,0 C134.9,581.4,136,582.5,137.3,582.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M190.7,649.1h-53.5c-1.3,0-2.4-1.1-2.4-2.4l0,0c0-1.3,1.1-2.4,2.4-2.4h53.5c1.3,0,2.4,1.1,2.4,2.4l0,0 C193.1,648.1,192,649.1,190.7,649.1z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "171.1,552.9 107.5,552.9 102.4,496.2 166,496.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "173.3,552.9 109.7,552.9 104.5,496.2 168.1,496.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "115.4,546.6 111.4,502.5 162.4,502.5 166.5,546.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "185.9,511.5 189.6,552.9 159.2,552.9 155.4,511.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "187.5,511.5 191.2,552.9 160.7,552.9 157,511.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "183.3,516.1 186.2,548.3 164.9,548.3 162,516.1  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "Shadow"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "_Path_",
    className: "st2",
    cx: 281.6,
    cy: 747.5,
    rx: 193.9,
    ry: 11.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "Bubble"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M235.2,445c3.8-9.5,14.5-14.2,24.1-10.5c0.2,0.1,0.5,0.2,0.7,0.3c8.5,3.8,13.1,14.7,9.9,23.4 c-1.6,4.4-4.8,8-9,10.2c-1.7,0.8-3.2,2.1-4.3,3.8l-2.6,4.2c-1.8,2.9-5.4,4.1-8.5,2.9l-6.7-2.6c-3.1-1.2-4.9-4.5-4.3-7.8l1-5.1 c0.3-1.8,0.1-3.6-0.5-5.3C233.5,454,233.5,449.2,235.2,445z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M244.7,487.6c0.4,0,0.8-0.1,1.2-0.3c1.6-0.7,2.3-2.5,1.6-4.1c-0.3-0.8-0.9-1.4-1.7-1.7l-8.8-3.5 c-1.6-0.7-3.4,0-4.1,1.6c-0.7,1.6,0,3.4,1.6,4.1c0.1,0,0.2,0.1,0.3,0.1l8.8,3.5C244,487.5,244.3,487.5,244.7,487.6z M235.9,478.8 c0.3,0,0.5,0,0.8,0.1l8.9,3.5c1.1,0.4,1.6,1.6,1.2,2.7c-0.2,0.5-0.6,0.9-1.1,1.2c-0.5,0.2-1.1,0.2-1.6,0l-8.8-3.5 c-1.1-0.4-1.6-1.7-1.2-2.7c0.2-0.5,0.6-0.9,1.1-1.1C235.4,478.9,235.6,478.8,235.9,478.8L235.9,478.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M240.2,492.9c0.8,0,1.5-0.5,1.8-1.2l0.1-0.4c0.4-1-0.1-2.1-1.1-2.5c0,0,0,0,0,0l-5.5-2.2 c-1-0.4-2.1,0.1-2.5,1.1c0,0,0,0,0,0l-0.1,0.4c-0.4,1,0.1,2.1,1.1,2.5l5.5,2.2C239.7,492.9,240,492.9,240.2,492.9z M234.9,487.5 c0.1,0,0.2,0,0.3,0.1l5.5,2.2c0.5,0.2,0.7,0.7,0.5,1.2c0,0,0,0,0,0l-0.1,0.4c-0.1,0.2-0.3,0.4-0.5,0.5c-0.2,0.1-0.5,0.1-0.7,0 l-5.5-2.2c-0.5-0.2-0.7-0.7-0.5-1.2c0,0,0,0,0,0l0.1-0.4C234.2,487.7,234.5,487.5,234.9,487.5L234.9,487.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M256.6,462.7c2.1,0,3.8-1.7,3.8-3.7c0-2.1-1.7-3.8-3.7-3.8c-1.5,0-2.9,0.9-3.5,2.4l-1.4,3.5l3.5,1.4 C255.7,462.6,256.2,462.7,256.6,462.7z M256.6,456.2c0.3,0,0.7,0.1,1,0.2c1.4,0.5,2.2,2.1,1.7,3.5c-0.5,1.4-2.1,2.2-3.5,1.7 c-0.1,0-0.1,0-0.2-0.1l-2.6-1l1-2.6C254.5,456.9,255.5,456.2,256.6,456.2L256.6,456.2z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "245.6,479.5 253.1,460.5 246.2,457.8 238.7,476.8 239.6,477.1 246.8,459.1 251.8,461 244.7,479.1  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M246.8,459.1l1.4-3.5c0.8-1.9-0.2-4.1-2.1-4.9s-4.1,0.2-4.9,2.1c-0.8,1.9,0.2,4.1,2.1,4.9c0,0,0,0,0,0 L246.8,459.1z M244.6,451.4c0.3,0,0.7,0.1,1,0.2c1.4,0.6,2.1,2.1,1.6,3.6l-1,2.6l-2.6-1c-1.4-0.6-2.1-2.2-1.6-3.6 C242.5,452.1,243.5,451.4,244.6,451.4L244.6,451.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M231.2,506.7c3.8,0,7.5-0.3,11.2-0.9l-0.2-1c-3.6,0.6-7.3,0.9-11,0.9L231.2,506.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M210.6,517.1L210,516c-1.8-4.1-2.2-8.7-1-13.1c3.9,1.4,7.9,2.4,12,3l0.1-1c-4.2-0.6-8.3-1.7-12.3-3.2 l-0.5-0.2l-0.1,0.5c-1.3,4.3-1.1,9,0.5,13.2c-12.3-4.9-25.1-22.2-25.1-42.9c0-18.4,21.4-33.3,47.7-33.3s47.7,15,47.7,33.3 c0,13.4-11.4,25.4-29,30.6l0.3,1c18-5.4,29.7-17.8,29.7-31.6c0-18.9-21.9-34.3-48.7-34.3s-48.7,15.4-48.7,34.3 c0,21.7,14,39.9,26.9,44.3L210.6,517.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M211,481l-33.3-6c-2.4-0.4-4-2.7-3.6-5.1l3.5-19.8c0.4-2.4,2.7-4,5.1-3.6l33.3,6c2.4,0.4,4,2.7,3.6,5.1 l-3.5,19.8C215.7,479.9,213.4,481.5,211,481z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "190.8,462.7 202.6,458.5 200.4,470.8  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "Character"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M401.3,638.8h-85c-1.8,0-3.2-1.4-3.2-3.2v-4.5c0-1.8,1.4-3.2,3.2-3.2h85c1.8,0,3.2,1.4,3.2,3.2v4.5 C404.4,637.4,403,638.8,401.3,638.8z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "317.3,741.5 314.7,741.5 317.6,638.8 321.1,638.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "317.3,741.5 314.7,741.5 317.6,638.8 321.1,638.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "340.6,741.5 343.1,741.5 340.2,638.8 336.7,638.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "340.6,741.5 343.1,741.5 340.2,638.8 336.7,638.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "377,741.5 374.4,741.5 377.3,638.8 380.9,638.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "377,741.5 374.4,741.5 377.3,638.8 380.9,638.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "400.3,741.5 402.8,741.5 399.9,638.8 396.4,638.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "400.3,741.5 402.8,741.5 399.9,638.8 396.4,638.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "290.2,715.4 281.2,712.3 288.6,691.3 297.7,694.3  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M281.9,708.9l9.9,4.3c0.3,0.1,0.5,0.5,0.4,0.8c0,0,0,0.1,0,0.1l-3.8,7.6c-0.5,0.8-1.5,1.2-2.4,0.8 c-3.4-1.6-4.9-2.5-9.3-4.4c-2.7-1.2-8.1-3.3-11.4-5.4c-3.3-2.2-0.7-5.3,0.9-4.6c3.9,1.5,10.4,1.4,13.9,0.6 C280.7,708.6,281.3,708.6,281.9,708.9z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "297.7,694.3 288.6,691.3 284.4,703.3 293.6,705.9  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M354.1,599.4c0,0-45,8.1-48.6,22.9c-7.1,29.2-23.2,74.9-23.2,74.9l17.1,4.9c0,0,24.5-52.4,27.6-70 c25.2,0,56,2,60-8.7c3.5-9.5,2.3-24,2.3-24L354.1,599.4z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "300.4,705.2 280.4,698.6 282.1,689.6 303.9,697.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "329.4,718.6 319.5,719.3 325.3,694.8 334.6,696.9  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M319.7,716.9l10.7-1.2c0.3-0.1,0.6,0.2,0.7,0.5c0,0,0,0.1,0,0.1l0.6,8.5c0,0.9-0.7,1.7-1.7,1.9 c-3.7,0.3-5.5,0.3-10.2,0.8c-2.9,0.3-8.6,1.2-12.6,1c-4-0.2-3.2-4.2-1.5-4.5c4.1-0.7,9.7-4,12.4-6.4 C318.5,717.3,319.1,717,319.7,716.9z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "334.6,696.9 325.3,694.8 322.4,707.2 331.8,708.8  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M377.6,599.4c0,0-54.7,8.2-52.2,28.9c3.6,29.9-5.7,73-5.7,73l17.5,3.2c0,0,12.9-53.7,13-71.6 c17.8,0,48.9,1.3,52.9-9.5c3.5-9.5,2.3-24,2.3-24H377.6z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "338.5,707.4 317.9,703 318.6,693.8 341.1,699.2  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M348.7,541.9c-1.5,5.7-2.9,11.5-4.3,17.2s-2.8,11.5-4.2,17.2l-1.1,4.2l-0.6,2.1l-0.3,1v0.1v0.1 c0,0,0-0.1,0-0.1c0.1-0.2,0.2-0.4,0.3-0.6c0-0.1,0.1-0.2,0.1-0.2l0.1-0.2l0.2-0.2c0.2-0.2,0.2-0.2,0.2-0.1 c-0.1,0.1-0.2,0.2-0.4,0.3c-0.4,0.3-0.9,0.6-1.4,0.8c-1.1,0.5-2.3,1-3.6,1.5c-5.2,1.9-10.9,3.6-16.5,5.4l0.9,6.4 c3.1,0,6.1-0.1,9.2-0.4c3.1-0.3,6.2-0.7,9.3-1.3c1.6-0.3,3.3-0.7,4.9-1.3c0.9-0.3,1.8-0.6,2.7-1.1c0.5-0.2,1.1-0.5,1.5-0.9 c0.7-0.4,1.3-1,1.9-1.6c0.2-0.2,0.4-0.4,0.5-0.6l0.3-0.4c0.1-0.1,0.2-0.3,0.3-0.5c0.2-0.4,0.4-0.7,0.5-1.1l0.2-0.5l0.4-1.1 l0.8-2.2c0.5-1.5,1-2.9,1.4-4.3c1.8-5.8,3.5-11.5,5-17.3s3-11.6,4.3-17.4L348.7,541.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M362.8,535c-5.5-6.1-14.2-1.8-17.9,11.9c-1.8,6.7-1.2,10.1-1.2,10.1l18.9,5.8 C366.7,553.8,370.2,543.3,362.8,535z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M362.8,535c-5.5-6.1-14.2-1.8-17.9,11.9c-1.8,6.7-1.2,10.1-1.2,10.1l18.9,5.8C366.7,553.8,370.2,543.3,362.8,535z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M307.4,587.7l1.7-0.5c1-0.3,2.1-0.4,3.2-0.3l3.6,0.4c2.4,0.6,4.4,2.1,5.6,4.3l1.2,2.4c-0.6,4.5-9.7,3-9.7,3 h-8.5l0.3-6C304.9,589.5,305.9,588.2,307.4,587.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M301.6,578c0.3,1.6,1,3.2,2.1,4.4c0.9,1.3,1.9,2.7,2.8,4c1.9,2.6,3.9,5.2,6,7.6c0.2,0.2,0.6,0.3,0.8,0.1 c0.2-0.2,0.3-0.5,0.1-0.7c-1.5-2.9-3.1-5.7-4.9-8.4c-0.9-1.4-1.7-2.7-2.6-4.1c-0.8-1.5-1.9-2.7-3.4-3.6c-0.3-0.2-0.7,0-0.9,0.3 C301.6,577.8,301.5,577.9,301.6,578z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M361.5,529l10.7-3l13.7-0.7c4.3-0.2,8.2,2.5,9.5,6.6c2.6,8,5,19.5,6.8,29.5c2.1,12.6,3.2,25.3,3.2,38h-51.2 c-1-28.5-4.4-42.4-6.4-52.4c-1.2-6.1,1.9-12.3,7.5-15L361.5,529z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M375.8,531c-1.3,3.3-6.3,10.5-12.2,13.3c-3.2-2.3-4-7.5-4.4-9.9L375.8,531z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M359.2,534.4c-0.4-1.3-0.2-2.7,0.4-3.9c0.8-1.3,0.6-2.8-0.2-4.3c-0.7-1.2-1.5-2.3-2.5-3.3l6.7-7.9l5.5-6.3 c0.5,5.9,0.9,13.3,5.6,17.9c1.6,1.6,2,2.1,1,4.5c-1.3,3.3-6,8-11.8,10.8C361.5,540.1,359.7,537.4,359.2,534.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M359,521.5l3.8-6.2c0.1,0.2,0.2,0.3,0.2,0.5c0.3,0.8,0.6,1.5,0.8,2.3c0.7,2.7-1.6,6.6-4.2,8.5 c-0.1-0.2-0.2-0.3-0.3-0.5c-0.6-1.2-1.4-2.2-2.3-3.2c0,0-0.1-0.1-0.2-0.1L359,521.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M345.8,506.8c-0.9,5.7-9-8.9-4.5-12.1C346.9,490.7,347.4,496,345.8,506.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M368.9,499.4c0.5,9.2,1.3,14.6-2.9,19.9c-6.4,8-18.6,5.4-21.9-3.5c-3-7.9-3.4-21.7,5.5-26.5 C358.4,484.4,368.4,490.2,368.9,499.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M350.7,493.8c0,0-5.9,5.8-10.1,3.4c-4.2-2.4-5-8.6,0-14c2.4-2.6,6.1-5.2,13.3-5c-0.6,0.6-1.3,1-2,1.2 c0,0,9.2-1.5,15.5,1.1c-0.5,0.8-1.2,1.4-2,1.9c6.2-0.5,12.2,2,8,7.8c5.6,0.5,6.9,7.8,3.9,12.5s-3.5,8.3-7.5,10.5 c0-6.5-1.5-8-1.5-8c-2.9-1.2-6.2-7.4-5.5-10.5C356.6,497.2,350.1,498.1,350.7,493.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M372,490.1c2-1.4,3.5-3.3,4.4-5.5c0.7,3.2-2.6,6.9-2.6,6.9L372,490.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M373.5,504.4c-0.1,2.1-0.9,4.1-2.3,5.7c-1.9,2-4.5,0.3-5-2.3c-0.4-2.3,0.6-5.8,3-6.9 C371.6,499.9,373.6,501.8,373.5,504.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M353.8,504.1c0.1,0.8-0.1,1.5-0.6,1.6s-1-0.4-1.2-1.2s0.1-1.5,0.6-1.6S353.7,503.4,353.8,504.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M345.3,506.2c0.2,0.8-0.1,1.5-0.6,1.6s-1-0.4-1.2-1.2c-0.2-0.8,0.1-1.5,0.6-1.6S345.2,505.4,345.3,506.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M348.1,506.1c-0.2,2.2-0.7,4.3-1.5,6.4c1.4,0.7,3.2-0.4,3.2-0.4L348.1,506.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M351.3,516.3c1.8-0.4,3.3-1.5,4.3-3c0-0.1,0-0.3-0.1-0.3c-0.1,0-0.2,0-0.3,0.1c-1.1,1.7-2.9,2.7-4.8,2.9 c-0.1,0-0.2,0.1-0.2,0.2c0,0,0,0,0,0c0,0.1,0.1,0.2,0.2,0.2c0,0,0,0,0,0C350.7,516.4,351,516.4,351.3,516.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M354.9,501.1c0.1,0,0.1-0.1,0.2-0.1c0.2-0.2,0.1-0.5-0.1-0.6c-1.1-0.9-2.6-1.3-4-0.9 c-0.2,0.1-0.4,0.3-0.3,0.6c0,0,0,0,0,0c0.1,0.2,0.3,0.4,0.6,0.3c1.1-0.3,2.3,0,3.1,0.7C354.6,501.1,354.8,501.1,354.9,501.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M344.3,501.2c0-0.1,0-0.2,0-0.2c-0.1-0.2-0.3-0.4-0.6-0.3c0,0,0,0,0,0c-1.4,0.4-2.5,1.4-3,2.8 c-0.1,0.2,0.1,0.5,0.3,0.6c0,0,0,0,0,0c0.2,0.1,0.5-0.1,0.6-0.3c0,0,0,0,0,0c0.4-1.1,1.3-1.9,2.4-2.2 C344.1,501.5,344.2,501.4,344.3,501.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M383.7,539.1c1.9,5.5,3.8,11.2,5.5,16.8c0.9,2.8,1.7,5.6,2.4,8.4c0.7,2.7,1.2,5.4,1.6,8.1 c0,0.3,0.1,0.6,0.1,0.9v0.4c0,0.1,0,0.4,0,0.3s0.1,0,0,0.3c-0.3,0.8-0.7,1.5-1.2,2.1c-1.7,1.9-3.7,3.6-5.8,5 c-4.8,3.2-9.8,6.2-15,8.7l2.1,6.1c3.1-0.7,6.2-1.5,9.1-2.6c3.1-1,6-2.3,8.9-3.7c3.2-1.5,6.1-3.5,8.7-5.9c1.7-1.5,3-3.4,3.9-5.4 c0.6-1.3,0.9-2.7,1-4.2c0-0.5,0-0.6,0-0.9v-0.7c0-0.5,0-0.9,0-1.4c-0.2-3.3-0.6-6.6-1.2-9.9c-0.6-3.2-1.4-6.2-2.2-9.3 c-1.6-6-3.6-12-5.8-17.8L383.7,539.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M386.6,525.3c-9.8-0.1-11.6,7.5-6.3,19.6c2,4.4,4.5,8.5,7.4,12.3l16.2-8.6 C401.7,539,397.7,525.4,386.6,525.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M359.6,589.1l3.6-2c0.6-0.3,1.3-0.4,1.9-0.4l4.3,0.6c2.9,0.3,5,2.5,6.6,4.4l1.8,2.2 c0.1,4.5-11.3,3.5-11.3,3.5l-10-0.1l0.3-3.9C356.9,591.6,358,590,359.6,589.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Desk"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 146.2,
    y: 595.1,
    className: "st8",
    width: 270.7,
    height: 12.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 329.1,
    y: 595.1,
    className: "st10",
    width: 87.8,
    height: 12.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 409.6,
    y: 607.8,
    className: "st8",
    width: 4.1,
    height: 139.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 409.6,
    y: 607.8,
    className: "st15",
    width: 4.1,
    height: 139.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 332.2,
    y: 607.8,
    className: "st8",
    width: 4.1,
    height: 139.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 332.2,
    y: 607.8,
    className: "st15",
    width: 4.1,
    height: 139.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226.8,
    y: 607.8,
    className: "st8",
    width: 4.1,
    height: 139.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226.8,
    y: 607.8,
    className: "st15",
    width: 4.1,
    height: 139.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 149.3,
    y: 607.8,
    className: "st8",
    width: 4.1,
    height: 139.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 149.3,
    y: 607.8,
    className: "st15",
    width: 4.1,
    height: 139.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M175.6,539.1h74c2.6,0.1,4.8,2,5.3,4.6l7.7,46.9c0.4,2-0.9,4-2.9,4.5c-0.3,0.1-0.6,0.1-0.9,0.1h-74 c-2.6-0.1-4.8-2-5.3-4.6l-7.7-46.9c-0.4-2,0.9-4,2.9-4.5C175,539.1,175.3,539.1,175.6,539.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M292.2,595.1h-69.7c-0.5,0-0.8-0.4-0.8-0.8v-1.4c0-0.5,0.4-0.8,0.8-0.8h69.7c0.5,0,0.8,0.4,0.8,0.8v1.4 C293,594.7,292.7,595.1,292.2,595.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M175.6,539.1h72.3c2.6,0.1,4.8,2,5.3,4.6l7.7,46.9c0.4,2-0.9,4-2.9,4.5c-0.3,0.1-0.6,0.1-0.9,0.1h-72.3 c-2.6-0.1-4.8-2-5.3-4.6l-7.7-46.9c-0.4-2,0.9-4,2.9-4.5C175,539.1,175.3,539.1,175.6,539.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M367.1,592.1c0,0-23.8,3.6-35.3-1.1c-5.4,2.6-24.5,3.9-31.2,1.1c2.1,2.4,6.9,3.1,6.9,3.1h50.3 C362.6,595.1,366.2,593,367.1,592.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M367.1,592.1c0,0-23.8,3.6-35.3-1.1c-5.4,2.6-24.5,3.9-31.2,1.1c2.1,2.4,6.9,3.1,6.9,3.1h50.3 C362.6,595.1,366.2,593,367.1,592.1z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWelcomeFigure);
export default __webpack_public_path__ + "static/media/welcomeFigure.0ce09a1900604a3b71b241684fea1b01.svg";
export { ForwardRef as ReactComponent };